import useSWR from "swr";

interface Location {
  id: string;
  city: string;
  streetAddress: string;
}

interface UseLocationsQueryReturn {
  data: Location[];
}

export function useLocationsQuery(
  locationIds: string[]
): UseLocationsQueryReturn {
  const ids = locationIds.join(",");
  const { data } = useSWR(`/api/v2/locations?ids=${ids}`);

  return { data: data?.map(toLocation) || [] };
}

function toLocation(data: any) {
  return {
    id: data?.id,
    city: data?.city,
    streetAddress: data?.street_address,
  };
}
